import { render, staticRenderFns } from "./HematologyParam.vue?vue&type=template&id=e60503c8&scoped=true"
import script from "./HematologyParam.vue?vue&type=script&lang=js"
export * from "./HematologyParam.vue?vue&type=script&lang=js"
import style0 from "./HematologyParam.vue?vue&type=style&index=0&id=e60503c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60503c8",
  null
  
)

export default component.exports